<app-loader></app-loader>
<router-outlet></router-outlet>
<app-tap-to-top ></app-tap-to-top>
 